module.exports = __webpack_public_path__ + "37721d9988620e49b09cd5dd1524b714.svg";